// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/work-item-schema',
  type: 'object',
  required: ['id', 'parentId'],
  properties: {
    id: {
      type: 'integer',
    },
    title: {
      type: 'string',
      nullable: true,
    },
    workItemState: {
      enum: [
        0,
        1,
        2,
        3,
        4,
      ],
    },
    workItemType: {
      enum: [
        0,
        1,
        2,
        3,
        4,
      ],
    },
    assignedPerson: {
      type: 'string',
      nullable: true,
    },
    parentId: {
      type: 'integer',
    },
    description: {
      type: 'string',
      nullable: true,
    },
    acceptanceCriteria: {
      type: 'string',
      nullable: true,
    },
    reproSteps: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
